import React from "react"
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";

const StageStatusView = (data) => {
    return (
        <div>
            <div className="overview-fph">
                <Heading level={3} type="h300" alignment="left">
                    <FormattedMessage id={data.stageStatus.title} defaultMessage={data.stageStatus.message}/>
                </Heading>
            </div>
            <Text type="d50">{data.stageStatus.value}</Text>
        </div>
    )
}

export default StageStatusView


// WEBPACK FOOTER //
// ./src/components/stageStatus/StageStatusView.js